import { Link } from "react-router-dom"

const Homebutton = () => {
    return (
      <div className="center">
        <Link to='/'>
          <button className='btn-answer'>Home</button>
        </Link>
      </div>
    );
}

export default Homebutton;